import { portaledMenuPortalRootCss } from './portaled_menu_styles'

const PORTAL_ID = 'meetings-filter-menu-portal'

let cachedPortalRoot = null

/**
 * Returns a stable DOM node for meetings filter-bar dropdown portals.
 *
 * The first call creates a `#meetings-filter-menu-portal` element on `document.body`;
 * later calls return that same node (cached) while it remains connected. This avoids
 * React-Aria portal issues in jsdom and shell overflow clipping in the browser.
 *
 * @returns {HTMLElement | null} Portal root, or `null` when `document` is unavailable (SSR/tests).
 *
 * @example
 * const portalRoot = getMeetingsFilterMenuPortalRoot()
 * return portalRoot && menu ? createPortal(menu, portalRoot) : menu
 */
export const getMeetingsFilterMenuPortalRoot = () => {
  if (typeof document === 'undefined') return null
  if (cachedPortalRoot?.isConnected) {
    cachedPortalRoot.dataset.reactAriaTopLayer = 'true'
    return cachedPortalRoot
  }

  cachedPortalRoot = document.createElement('div')
  cachedPortalRoot.setAttribute('id', PORTAL_ID)
  cachedPortalRoot.dataset.reactAriaTopLayer = 'true'
  cachedPortalRoot.className = portaledMenuPortalRootCss
  document.body.appendChild(cachedPortalRoot)

  return cachedPortalRoot
}
